module.exports = __webpack_public_path__ + "media/img/logos/2024/horizontal/weltumwelttag-96c9d18cb8185964ec6c096d77040341.svg";